export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="bg-neutral-900 text-neutral-400 py-12 border-t border-neutral-800 text-xs"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
                <span className="display-type text-xl text-white tracking-wider block">
                    TMZ GUINCHO
                </span>
                <p className="text-neutral-500 mt-1">
                    Tomizo Logística e Transporte Ltda. &bull; Guincho de plataforma em Miracatu e
                    região &bull; Rodovia Régis Bittencourt km 377.
                </p>
            </div>
            <div className="text-center md:text-right mono-type text-[11px] text-neutral-500">
                Miracatu - SP &bull; Todos os direitos reservados.
            </div>
        </div>
    </footer>
);
